<style scoped>
</style>
<template>
    <div class="row">
        <a v-shortkey="{keys:'w', title:'Workslate', description:'Show / Hide Working Bags'}" @shortkey="flipShowWorking"></a>
        <a v-shortkey="{keys:'r', title:'Workslate', description:'Show / Hide Completed Bags'}" @shortkey="flipShowReady"></a>
        <a v-shortkey="{keys:'f', title:'Workslate', description:'Search Bag Table'}" @shortkey="FindFocus"></a>
        <div class="col-md-12" style="margin-bottom:0px;margin-top:5px">



            <!--<a class="btn btn-xs" :class="{'btn-success': showEmpty, 'btn-default':!showEmpty}"
               href="#" @click.prevent="flipShowEmpty"
               style="padding-left:10px;padding:6px; width:130px">
                <span class="fa-stack fa-md" style="margin:0px;padding:0px">
                    <i class="fa fa-square-o fa-stack-2x"></i>
                    <i v-if="showEmpty" class="fa fa-check fa-stack-1x"></i>
                </span>&nbsp;&nbsp;
                Empty
            </a>-->



            <a class="btn btn-xs" :class="{'btn-success': showWorking, 'btn-default':!showWorking}"
               href="#" @click.prevent="flipShowWorking"
               style="padding-left:10px;padding:6px; width:130px">
                <span class="fa-stack fa-md" style="margin:0px;padding:0px">
                    <i class="fa fa-square-o fa-stack-2x"></i>
                    <i v-if="showWorking" class="fa fa-check fa-stack-1x"></i>
                </span>&nbsp;&nbsp;
                Working
            </a>


            <a class="btn btn-xs" :class="{'btn-success': showReady, 'btn-default':!showReady}"
               href="#" @click.prevent="flipShowReady"
               style="padding-left:10px;padding:6px; width:130px">
                <span class="fa-stack fa-md" style="margin:0px;padding:0px">
                    <i class="fa fa-square-o fa-stack-2x"></i>
                    <i v-if="showReady" class="fa fa-check fa-stack-1x"></i>
                </span>&nbsp;&nbsp;
                Completed
            </a>

            <a class="btn btn-primary btn-xs" @click="getDbRecord" style="width:130px;padding:10px">
                <i class="fa fa-refresh" />
                <span>Refresh </span>
            </a>
        </div>
        <div class="col-md-12">

            <div class="panel panel-default" style="margin-top:10px">
                <div class="panel-heading">
                    <h3 class="panel-title">
                        <strong>Workslate</strong>
                        <span class="pull-right">
                            <span class="text-danger" v-if="completedCount + workingCount + emptyCount > 0">
                                <!--<i class="fa fa-exclamation-circle"></i>-->
                                <span v-if="completedCount > 0">[{{completedCount}}] Complete </span>
                                <span v-if="workingCount > 0">[{{workingCount}}] Working </span>
                                <span v-if="emptyCount > 0">[{{emptyCount}}] Empty </span>
                                Bags Selected
                            </span>
                            <span v-if="completedCount + workingCount + emptyCount == 0 && selectionEnabled" class="text-warning">No Bags Selected</span>
                            &nbsp;&nbsp;
                            <span class="pull-right text-warning">


                                <a v-if="!selectionEnabled" class="btn btn-xs btn-primary" href="#" @click.prevent="flipSelectionMode" style="margin-top:-5px">
                                    Enable Selection
                                </a>
                                <a v-if="selectionEnabled" class="btn btn-xs btn-primary" href="#" @click.prevent="flipSelectionMode" style="margin-top:-5px">
                                    Disable Selection
                                </a>
                            </span>
                        </span>
                    </h3>

                </div>
                <div class="panel-body">


                    <!--<a v-if="!selectionEnabled" class="btn btn-xs btn-primary" href="#" @click.prevent="flipSelectionMode"
                       style="padding:6px; width:150px; margin:3px; margin-bottom:10px; ">
                        Enable Selection
                    </a>-->
                    <span v-if="selectionEnabled">
                        <!--<a class="btn btn-xs btn-primary" href="#" @click.prevent="flipSelectionMode"
                           style="padding:6px; width:150px; margin:3px; margin-bottom:10px; ">
                            Disable Selection
                        </a>-->
                        <a class="btn btn-xs btn-default" href="#" @click.prevent="changeSelectionAll(true)"
                           style="padding:6px; width:150px; margin:3px; margin-bottom:10px;">
                            Select All
                        </a>
                        <a class="btn btn-xs btn-default" href="#" @click.prevent="changeSelectionAll(false)"
                           style="padding:6px; width:150px; margin:3px; margin-bottom:10px; ">
                            Deselect All
                        </a>
                    </span>
                    <datatable ref="datatable" tablename="datatable-fmd-bag-list" :columns="columns" :source="getRecords" @selected="recordSelected" :datachanged="tableUpdateCounter" :order="tableOrder"></datatable>
                    <span style="margin-top:-10px">
                        <a class="btn btn-warning" href="#" @click.prevent="deliverBulk"
                           v-if="completedCount > 0 && !isUpdating">
                            <i class="fa fa-paper-plane"></i>
                            <strong>Deliver </strong>{{completedCount}} completed bags
                        </a>
                        <a class="btn btn-warning" href="#" @click.prevent="completeBulk"
                           v-if="workingCount > 0 && !isUpdating">
                            <i class="fa fa-shopping-bag"></i>
                            <strong>Complete </strong>{{workingCount}} working bags
                        </a>
                        <a class="btn btn-danger" href="#" @click.prevent="deleteBulk"
                           v-if="emptyCount > 0 && !isUpdating">
                            <i class="fa fa-trash"></i>
                            Delete {{emptyCount}} Empty Bags
                        </a>


                        <a class="btn btn-warning" @click.prevent=""
                           v-if="isUpdating">
                            <i class="fa fa-refresh fa-spin"></i>&nbsp;&nbsp;&nbsp;Working
                        </a>
                    </span>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="myModal" role="dialog">
            <div class="modal-dialog modal-sm" style="width:450px;">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <h4 class="modal-title">
                            {{
                            currentAction == "complete" ? "Complete Bags" :
                            currentAction == "deliver" ? "Deliver Bags" :
                            currentAction == "delete" ? "Delete Bags" : ""
                            }}
                        </h4>
                    </div>
                    <div class="modal-body">

                        Please confirm that you want to {{
                        currentAction == "complete" ? "Complete " + workingCount +" ready":
                        currentAction == "deliver" ? "Deliver " + completedCount +" completed":
                        currentAction == "delete" ? "Delete " +emptyCount +" empty": ""
                        }}
                        Bags
                        <br />
                        <br />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success btn-sm" data-dismiss="modal">Cancel </button>
                        <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click.prevent="confirmBulkAction">Confirm </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import FmdDal from '../../../scripts/FmdDal'
    import datatable from "../../corecontrols/datatable/datatable.scp.html";
    import Formatter from "../../corecontrols/formatters/Formatter"
    import SelectableObject from './SelectableObject'
    import toastr from "toastr"

    export default {
        props: [],
        data: function () {
            var formatDate = Formatter.FormatDate;

            return {
                showReady: true,
                showWorking: true,
                showEmpty: true,
                showDelivered: true,
                bags: [],
                loaded: false,
                loadingTask: {},
                FmdDal: null,
                initialized : false,

                currentAction: "",
                selectionEnabled: false,
                isUpdating: false,
                workingCount: 0,
                completedCount: 0,
                emptyCount: 0,

                tableUpdateCounter: 0,
                filteredBags: [],
                tableOrder: [[4, 'desc']],
                columns: [
                    {
                        name: "[Select]", data: "IsSelected", render: function (data) {
                            return data
                                ? "&nbsp;&nbsp;<i class='fa fa-check text-success'>&nbsp;"
                                : "&nbsp;&nbsp;&nbsp;&nbsp;"

                        },
                        "orderable": false
                    },

                    {
                        name: "FMD Status", data: "Item.bagFMDStatus", render: function (data, type, row) {
                            var icon = "fa-refresh"
                            var style = "text-primary"
                            var text = ""
                            if (data == "10") {
                                icon = "fa-hourglass"
                                style = "text-warning"
                                text = "Pending"
                            }
                            if (data == "20") {
                                icon = "fa-check"
                                style = "text-success"
                                text = "Verified"
                            }
                            if (data == "30") {
                                icon = "fa-exclamation-triangle"
                                style = "text-danger"
                                text = "Failed"
                            }
                            return "<div class='" + style + "'><i class='fa " + icon + "'></i> <span>" + text + "</span> </div>";
                        },
                        "orderable": true,
                    },
                    {
                        name: "Bag Status", data: "Item.bagStatus", render: function (data, type, row) {
                            var icon = "fa-refresh"
                            var style = "text-primary"
                            var text = ""
                            if (data == "10") {
                                icon = "fa-cog"
                                style = "text-warning"
                                text = "Working"
                            }
                            if (data == "20") {
                                icon = "fa-shopping-bag"
                                style = "text-success"
                                text = "Completed"
                            }
                            return "<div class='" + style + "'><i class='fa " + icon + "'></i> <span>" + text + "</span> </div>";
                        }
                    },
                    {
                        name: "Item.Name",
                        render: function (data, type, row) {
                            return row.patientId ? row.firstName + ' ' + row.lastName : ''
                        }
                    },
                    {
                        name: "Aggregated Code", data: "Item.aggregatedCode"
                    },
                    {
                        name: "Created", data: "Item.whenCreated", render: function (data, type, row) {
                            return Formatter.FormatDateTime(data)
                        }
                    },
                    {
                        name: "Dob", data: "Item.dob", render: function (data, type, row) {
                            return formatDate(data)
                        }
                    },
                    {
                        name: "Items", data: "Item.numberOfMeds", render: function (data, type, row) {
                            return data
                        }
                    },
                ]
            }
        },
        created() {
            var unitId = this.$root.CurrentUnitId;
            this.LoadState()
            this.FmdDal = new FmdDal(unitId, this.$root.UiSession);
            //this.initialDataLoadTask = this.getDbRecord();
        },
        mounted() {
            //alert("Mounting bag " + this.$root.CurrrentUnitId);
            //console.log("Mounting bag ", this.$root, this.$root.CurrentUnitId, unitId)
            //this.FmdDal = new FmdDal(unitId, this.$root.UiSession);
            //this.showDelivered = !this.showDelivered;
            //this.initialDataLoadTask = this.getDbRecord();

        },
        methods: {
            LoadState() {
                var filters = localStorage.getItem("fmd-workslate-filters");

                if (filters === null) {
                    var settings = {
                        showWorking: true,
                        showReady: true
                    }
                    localStorage.setItem("fmd-workslate-filters", JSON.stringify(settings));
                }
                else {
                    var fo = JSON.parse(filters)
                    this.showWorking = fo.showWorking;
                    this.showReady = fo.showReady;
                }
            },
            FindFocus: function () {
                $(this.$el).find('div.dataTables_filter input').focus();
            },
            flipShowReady() {
                this.showReady = !this.showReady;
                localStorage.setItem("fmd-workslate-filters", JSON.stringify({
                    showWorking: this.showWorking,
                    showReady: this.showReady
                }));
                this.filterBags()
                this.tableUpdateCounter++;
            },
            flipShowWorking() {
                this.showWorking = !this.showWorking;
                localStorage.setItem("fmd-workslate-filters", JSON.stringify({
                    showWorking: this.showWorking,
                    showReady: this.showReady
                }));
                this.filterBags()
                this.tableUpdateCounter++;
            },
            flipSelectionMode() {
                this.selectionEnabled = !this.selectionEnabled;
                this.filterBags();
                this.tableUpdateCounter++;
            },
            getDbRecord() {
                if (!this.FmdDal) {
                    return;
                }

                this.loadingTask = this.FmdDal.GetActiveBags().then(data => {
                    console.log("Bags : ", data)
                    this.bags = data
                    return this.loaded = true;
                });

                return this.loadingTask.then(() => {
                    this.filterBags()
                    return true;
                    //return this.tableUpdateCounter++;
                })

            },
            getRecords: function (callback) {
                if (this.initialized) {
                    callback({ data: this.filteredBags });
                }
                else {
                    this.getDbRecord().then(() => {
                        this.initialized = true;
                        callback({ data: this.filteredBags });
                    })
                }
            },
            changeSelectionAll(select) {
                this.workingCount = 0
                this.completedCount = 0
                this.emptyCount = 0

                this.filteredBags = this.filteredBags.map(i => {
                    i.IsSelected = select;

                    if (i.IsSelected) {
                        if (i.Item.numberOfMeds == 0) this.emptyCount++;
                        else if (i.Item.bagStatus == 10) this.workingCount++;
                        else if (i.Item.bagStatus == 20) this.completedCount++;
                    }
                    return i;
                })

                this.tableUpdateCounter++;
            },
            recordSelected(record) {
                console.log("Record Selected", record);

                if (this.selectionEnabled) {
                    this.workingCount = 0
                    this.completedCount = 0
                    this.emptyCount = 0;

                    this.filteredBags = this.filteredBags.map(i => {
                        if (i.Item.id == record.Item.id) {
                            i.IsSelected = !i.IsSelected
                        }
                        if (i.IsSelected) {
                            if (i.Item.numberOfMeds == 0) this.emptyCount++;
                            else if (i.Item.bagStatus == 10) this.workingCount++;
                            else if (i.Item.bagStatus == 20) this.completedCount++;

                        }
                        return i;
                    })

                    this.tableUpdateCounter++;
                }
                else {
                    console.log("Record Selected", record);
                    this.$router.push({ path: 'bag/' + record.Item.id });
                }
                
            },
            filterBags() {
                this.workingCount = 0
                this.completedCount = 0
                this.emptyCount = 0;

                this.filteredBags = this.bags.filter(f =>
                    (
                        (f.bagStatus == 20 && this.showReady) ||
                        (f.bagStatus == 10 && this.showWorking )
                    ) 
                ).map(i => new SelectableObject(i, false))

                this.filteredBags;
            },
            deliverBulk() {
                this.currentAction = "deliver"
                $(this.$refs.myModal).modal('show');
            },
            completeBulk() {
                this.currentAction = "complete"
                $(this.$refs.myModal).modal('show');
            },
            deleteBulk() {
                this.currentAction = "delete"
                $(this.$refs.myModal).modal('show');
            },
            confirmBulkAction() {
                $(this.$refs.myModal).modal('hide');

                this.isUpdating = true;
                var selected = this.filteredBags.filter(i => i.IsSelected).map(i => i.Item);

                if (this.currentAction == "delete") {
                    var toBeDeleted = selected.filter(i => i.numberOfMeds == 0)
                    this.DeleteMultipleBags(toBeDeleted).then(() => this.isUpdating = false)
                }
                else {

                    if (this.currentAction == "deliver") {
                        var toBeDelivered = selected.filter(i => i.bagStatus == 20);
                        this.UpdateMultipleBags(toBeDelivered, 30).then(() => this.isUpdating = false)

                    }
                    else if (this.currentAction == "complete") {
                        var toBeCompleted = selected.filter(i => i.bagStatus == 10 && i.numberOfMeds > 0);
                        this.UpdateMultipleBags(toBeCompleted, 20).then(() => this.isUpdating = false)
                    }
                }
            },
            DeleteMultipleBags(bags) {
                console.log("Bulk Action : Deleting bags", bags)
                var task = null;

                bags.forEach(bag => {
                    if (task) {
                        Promise.all([task]);
                        task = task.then(() => this.DeleteBag(bag.id, bag.patientId))
                    }
                    else {
                        task = this.DeleteBag(bag.id, bag.patientId)
                    }
                })

                return task
                    .then(() => this.getDbRecord())
                    .then(() => this.tableUpdateCounter++)
            },
            UpdateMultipleBags(bags, status) {
                console.log("Bulk Action : Updateing Status", status, bags)
                var task = null;
                bags.forEach(bag => {
                    if (task) {
                        Promise.all([task]);
                        task = task.then(() => this.UpdateStatus(bag.id, status))
                    }
                    else {
                        task = this.UpdateStatus(bag.id, status)
                    }
                })

                return task
                    .then(() => this.getDbRecord())
                    .then(() => this.tableUpdateCounter++)
            },
            UpdateStatus(id, status) {
                console.log("Updating Bag " + id + " Status : " + status);
                return this.FmdDal.UpdateBagStatus(id, status)
            },
            DeleteBag(bagId, patientId) {
                console.log("Deleting Bag ", bagId, patientId)
                //return new Promise(resolve => setTimeout(resolve, 50))
                return this.FmdDal.DeleteBag(bagId, patientId)
            }
            ,cancelDeliver() {
                $(this.$refs.myModal).modal('hide');
            }
        },
        components: {
            datatable
        }
    }
</script>


// WEBPACK FOOTER //
// deliver.scp.html?302280bd